'use client';

// base
import React, { useEffect, useState } from 'react';

// styles
import { StyledClock } from './style';

// libraries
import dayjs from 'dayjs';

interface ClockProps {
  currentDate: dayjs.Dayjs;
}

export const Clock: React.FC<ClockProps> = ({ currentDate }) => {
  const [value, setValue] = useState(dayjs());

  useEffect(() => {
    if (currentDate) {
      setValue(currentDate);
    }
  }, [currentDate]);

  useEffect(() => {
    const today = value;

    const nowH = today.hour();
    const nowM = today.minute();
    const nowS = today.second();

    const degH = nowH * (360 / 12) + nowM * (360 / 12 / 60);
    const degM = nowM * (360 / 60);
    const degS = nowS * (360 / 60);

    const eleH = document.querySelector<HTMLDivElement>('.clock-hour-hr');
    const eleM = document.querySelector<HTMLDivElement>('.clock-minute-mt');
    const eleS = document.querySelector<HTMLDivElement>('.clock-second-sc');

    if (!eleH || !eleM || !eleS) return;

    eleH.style.transform = `rotate(${degH}deg)`;
    eleM.style.transform = `rotate(${degM}deg)`;
    eleS.style.transform = `rotate(${degS}deg)`;

    return () => {
      eleH.style.transform = `rotate(0deg)`;
      eleM.style.transform = `rotate(0deg)`;
      eleS.style.transform = `rotate(0deg)`;
    };
  }, [value]);

  return (
    <StyledClock>
      <div className="clock-base">
        <div className="clock-hour">
          <div className="clock-hour-hr" />
        </div>

        <div className="clock-minute">
          <div className="clock-minute-mt" />
        </div>

        <div className="clock-second">
          <div className="clock-second-sc" />
        </div>
      </div>
    </StyledClock>
  );
};
